<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ul8MK/tc-custom/9780226045825.jpg?1731838270990" alt="This image is the cover for the book Curiosity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Curiosity
      </h1>
      <p class="bookDescription body article font2">
        <p>With the recent landing of the Mars rover Curiosity, it seems safe to assume that the idea of being curious is alive and well in modern science—that it’s not merely encouraged but is seen as an essential component of the scientific mission. Yet there was a time when curiosity was condemned. Neither Pandora nor Eve could resist the dangerous allure of unanswered questions, and all knowledge wasn’t equal—for millennia it was believed that there were some things we should not try to know. In the late sixteenth century this attitude began to change dramatically, and in <i>Curiosity:</i><i>How Science Became Interested in Everything,</i> Philip Ball investigates how curiosity first became sanctioned—when it changed from a vice to a virtue and how it became permissible to ask any and every question about the world. Looking closely at the sixteenth through eighteenth centuries, Ball vividly brings to life the age when modern science began, a time that spans the lives of Galileo and Isaac Newton. In this entertaining and illuminating account of the rise of science as we know it, Ball tells of scientists both legendary and lesser known, from Copernicus and Kepler to Robert Boyle, as well as the inventions and technologies that were inspired by curiosity itself, such as the telescope and the microscope. The so-called Scientific Revolution is often told as a story of great geniuses illuminating the world with flashes of inspiration. But <i>Curiosity</i> reveals a more complex story, in which the liberation—and subsequent taming—of curiosity was linked to magic, religion, literature, travel, trade, and empire. Ball also asks what has become of curiosity today: how it functions in science, how it is spun and packaged for consumption, how well it is being sustained, and how the changing shape of science influences the kinds of questions it may continue to ask. Though proverbial wisdom tell us that it was through curiosity that our innocence was lost, that has not deterred us. Instead, it has been completely the contrary: today we spend vast sums trying to reconstruct the first instants of creation in particle accelerators, out of a pure desire to <i>know</i>. Ball refuses to let us take this desire for granted, and this book is a perfect homage to such an inquisitive attitude.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip Ball
      </h2>
      
      <p class="authorDescription body article"><B>Philip Ball</B> is a freelance writer who lives in London. He worked for over twenty years as an editor for <I>Nature</I>, writes regularly in the scientific and popular media, and has authored many books on the interactions of the sciences, the arts, and the wider culture, including, most recently, <I>Serving the Reich: The Struggle for the Soul of Physics under Hitler</I>, also published by the University of Chicago Press<I>.</I><br><br><br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef1137e4